<template>
  <div class="online-time">
    <div class="content">
      <img src="@/assets/在线时长.png" alt />
      <div class="title">在线时长</div>
      <div class="time-unit">
        <span class="time">{{parseInt(my.onlineTime / 1000 / 60)}}</span>
        <span class="unit">{{"分钟"}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyOnlineTime",
  props: ["my"]
};
</script>

<style lang="less" scoped>
.online-time {
  background: white;

  width: 100%;

  padding: 50px 0;

  .content {
    width: 750px;
    margin: 0 auto;
  }
  // padding: 50px auto;

  // padding: 100px;
  img {
    width: 100%;
    // margin: 50px auto;
  }

  .title {
    position: relative;
    color: #1b994f;
    top: -160px;
    text-align: center;
  }

  .time-unit {
    position: relative;
    text-align: center;
    top: -160px;
  }

  .time {
    color: white;
    font-size: 34px;
    letter-spacing: 5px;
    padding-right: 10px;
  }

  .unit {
    color: white;
    font-size: 18px;
  }
}
</style>

